var NavDrawerDomElements = function() {
    this.getMakeModelYearDom = function() {
        return {
            modelsListDiv: $('#nav-drawer-carousel .model-slide .list-group'),
            yearsListDiv: $('#nav-drawer-carousel .year-slide .list-group')
        };
    };
};

module.exports = new NavDrawerDomElements();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/dom-elements.js
// module id = 69
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14